import {
  PM_TICKET,
  PM_TICKET_DETAILS,
  PM_ASSIGNEE,
  PM_TICKET_STATUS,
  PM_TICKET_ASSIGNEE,
  PM_TICKET_FILTER,
  PM_SLOT_DETAILS,
  PROJECT_PM_TICKET_DETAILS
} from "./type";

const initalState = {
  pmTicket: {},
  pmTicketDetails: {},
  pmAssigneeList: [],
  pmTicketStatus: [],
  pmTicketAssignee: [],
  pmTicketFilter: {},
  pmSlotDetails: {},
  projectPmSlotDetails:[]
};

const pmTicketReducer = (state = initalState, action) => {
  const { type, payload } = action;
  switch (type) {
    case PM_TICKET:
      return {
        ...state,
        pmTicket: payload,
      };
    case PM_TICKET_DETAILS:
      return {
        ...state,
        pmTicketDetails: payload,
      };
    case PM_ASSIGNEE:
      return {
        ...state,
        pmAssigneeList: payload,
      };
    case PM_TICKET_STATUS:
      return {
        ...state,
        pmTicketStatus: payload,
      };
    case PM_TICKET_ASSIGNEE:
      return {
        ...state,
        pmTicketAssignee: payload,
      };
     case PM_TICKET_FILTER : 
      return {
        ...state,
        pmTicketFilter: payload,
      };
    case PM_SLOT_DETAILS:
      return {
        ...state,
        pmSlotDetails: payload,
      }; 
    case PROJECT_PM_TICKET_DETAILS :
      return {
        ...state,
        projectPmSlotDetails: payload,
      }; 
    default:
      return {
        ...state,
      };
  }
};

export default pmTicketReducer;
